export const locations = [
  "All Locations",
  "New York-Newark-Jersey City, NY-NJ-PA MSA",
  "Los Angeles-Long Beach-Anaheim, CA MSA",
  "Chicago-Naperville-Elgin, IL-IN-WI MSA",
  "Dallas-Fort Worth-Arlington, TX MSA",
  "Houston-The Woodlands-Sugar Land, TX MSA",
  "Washington-Arlington-Alexandria, DC-VA-MD-WV MSA",
  "Miami-Fort Lauderdale-Pompano Beach, FL MSA",
  "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD MSA",
  "Atlanta-Sandy Springs-Alpharetta, GA MSA",
  "Boston-Cambridge-Newton, MA-NH MSA",
  "Phoenix-Mesa-Chandler, AZ MSA",
  "San Francisco-Oakland-Berkeley, CA MSA",
  "Riverside-San Bernardino-Ontario, CA MSA",
  "Detroit-Warren-Dearborn, MI MSA",
  "Seattle-Tacoma-Bellevue, WA MSA",
  "Minneapolis-St. Paul-Bloomington, MN-WI MSA",
  "San Diego-Chula Vista-Carlsbad, CA MSA",
  "Tampa-St. Petersburg-Clearwater, FL MSA",
  "Denver-Aurora-Lakewood, CO MSA",
  "St. Louis, MO-IL MSA",
  "Baltimore-Columbia-Towson, MD MSA",
  "Orlando-Kissimmee-Sanford, FL MSA",
  "Charlotte-Concord-Gastonia, NC-SC MSA",
  "San Antonio-New Braunfels, TX MSA",
  "Portland-Vancouver-Hillsboro, OR-WA MSA",
  "Sacramento–Roseville–Folsom, CA MSA",
  "Pittsburgh, PA MSA",
  "Las Vegas-Henderson-Paradise, NV MSA",
  "Cincinnati, OH-KY-IN MSA",
  "Austin-Round Rock-Georgetown, TX MSA",
  "Kansas City, MO-KS MSA",
  "Columbus, OH MSA",
  "Cleveland-Elyria, OH MSA",
  "Indianapolis-Carmel-Anderson, IN MSA",
  "San Jose-Sunnyvale-Santa Clara, CA MSA",
  "Nashville-Davidson–Murfreesboro–Franklin, TN MSA",
  "Virginia Beach-Norfolk-Newport News, VA-NC MSA",
  "Providence-Warwick, RI-MA MSA",
  "Milwaukee-Waukesha, WI MSA",
  "Jacksonville, FL MSA",
  "Oklahoma City, OK MSA",
  "Raleigh-Cary, NC MSA",
  "Memphis, TN-MS-AR MSA",
  "Richmond, VA MSA",
  "Louisville/Jefferson County, KY-IN MSA",
  "New Orleans-Metairie, LA MSA",
  "Salt Lake City, UT MSA",
  "Hartford-East Hartford-Middletown, CT MSA",
  "Birmingham-Hoover, AL MSA",
  "Buffalo-Cheektowaga, NY MSA"
];

export const topics = [
  "All Topics",
  "abortion",
  "affordable housing",
  "animal rights",
  "bullying",
  "campaign finance reform",
  "civil rights",
  "climate change",
  "corporate influence",
  "education",
  "green energy",
  "gun control",
  "health care",
  "homeless",
  "immigration",
  "income inequality",
  "ineffective government",
  "lgbt",
  "police brutality",
  "pollution",
  "poverty",
  "racism",
  "student loan debt",
  "terrorism",
  "unemployment",
  "vaccines"
];
